/**
 * Service: dedupeApi
 */
angular.module('acme.common.service.dedupeApi', [
    'acme.common.factory.apiVersion'
])
.service('DedupeApiService', ['$http', 'ApiVersionFactory', function($http, ApiVersionFactory) {

    return {

        service: '',

        init: function(endpoint) {
            this.service = endpoint + '/customers/pos/customerswithduplicates';
            return true;
        },

        /**
         * Returns a list of possible duplicates for any number of customers
         * @param {membershipCard | Array<membershipCard>} membershipCards 
         * @returns {Promise<Array>}
         */
        list: function(membershipCards) {
            var av = new ApiVersionFactory();
            membershipCards = Array.isArray(membershipCards) ? membershipCards : [membershipCards];

            var customers = membershipCards.map(function(membershipCard) {
                return {
                    firstName: membershipCard.firstName,
                    middleName: membershipCard.middleName,
                    lastName: membershipCard.lastName,
                    email: membershipCard.email,
                    phone: membershipCard.phone,
                    address: [
                        {
                            type: 'primary',
                            streetAddress1: membershipCard.address.streetAddress1,
                            streetAddress2: membershipCard.address.streetAddress2,
                            city: membershipCard.address.city,
                            state: membershipCard.address.state,
                            country: membershipCard.address.country
                        }
                    ]
                };
            });

            return $http({
                method: 'post',
                url: av.init({ url: this.service, version: 'v2' }),
                data: {
                    customers: customers
                }
            });
        }
    };

}]);